export default __webpack_public_path__ + "static/email-capture-2b82fcaf60e08d26a0df5c73a83ca043.png";